
import { useUUID } from "@/hooks/useUUID";
import { defineComponent } from "vue";

export type SelectDropdownOption = {
	value: string;
	title: string;
	enabled: boolean;
};

export default defineComponent({
	props: {
		text: {
			type: String,
			default: "Select",
		},
		options: {
			type: Array as () => SelectDropdownOption[],
			required: true,
		},
	},
	setup() {
		const componentUUID = useUUID();
		return { componentUUID };
	},
});
